module.exports = __webpack_public_path__ + "static/media/office-depot.63ace32c.svg";